module.exports = __webpack_public_path__ + "img/qualityInspection.124de392.png";